export default "__VITE_ASSET__BPf2PFeU__"